import './points-balance.scss'

import { Skeleton } from '@acctglobal/skeleton'
import React from 'react'

import { PointsBalanceError } from './components/PointsBalanceError'
import { PointsCurrencyIcon } from '../../../../assets/PointsCurrencyIcon'
import { useCardContext } from '../../../../contexts/CardContext'
import { DynamicTitle } from '../../../common/DynamicTitle'

interface PointsBalanceProps {
  visibility: boolean
  isDescription?: boolean
}

export const PointsBalance = ({
  visibility,
  isDescription = true,
}: PointsBalanceProps) => {
  const { balance } = useCardContext()

  if (!visibility) {
    return null
  }

  if (balance?.loading) {
    return (
      <div className="club-card-user-pointsBalance">
        <Skeleton
          width="100%"
          height="100%"
          backgroundColor="var(--color-grayScale-faded)"
          borderRadius={8}
        />
      </div>
    )
  }

  if (balance?.error) {
    return <PointsBalanceError />
  }

  return (
    <div className="club-card-user-pointsBalance">
      <div className="club-card-user-pointsBalance-container">
        <DynamicTitle
          className="pointsBalance-title"
          titleLevel={2}
          title="Seus pontos"
        />
        <div className="pointsBalance-infos">
          <div className="pointsBalance-infos-quantity">
            <PointsCurrencyIcon />
            <p className="pointsBalance-infos-quantity-text">
              {balance?.data?.toLocaleString('pt-BR') ?? '0'}
              <span> pts</span>
            </p>
          </div>
          {isDescription && (
            <p className="pointsBalance-infos-description">
              Troque seus pontos por vale-compras e economize!
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
